import React from 'react';
import { Check, Clock } from 'lucide-react';
import { Button, TrustBadges } from './SharedUI';
interface OfferProps {
  timeString: string;
  formattedPrice: string;
  formattedOldPrice: string;
}
export function Offer({
  timeString,
  formattedPrice,
  formattedOldPrice
}: OfferProps) {
  const includes = ['5 tomos digitales completos (descarga inmediata)', '4 sesiones listas para usar desde mañana', 'Ficha de scouting y análisis de rival', 'Programa físico de 4 semanas', '5 juegos reducidos con reglas completas', 'Recursos para llenar tu agenda sin publicidad', 'Garantía de devolución de 45 días sin preguntas'];
  return <section id="offer-section" className="py-16 md:py-24 px-4 scroll-mt-20" data-id="element-28">
      <div className="max-w-4xl mx-auto" data-id="element-29">
        <div className="bg-navy-800 rounded-3xl border-2 border-brand-green overflow-hidden shadow-2xl shadow-brand-green/20 relative" data-id="element-30">
          {/* Urgency Header */}
          <div className="bg-brand-red text-white text-center py-3 px-4 font-bold flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-31">
            <span className="uppercase tracking-wide text-sm sm:text-base" data-id="element-32">
              ⚠️ Esta oferta termina pronto
            </span>
            <div className="flex items-center gap-2 bg-black/20 px-3 py-1 rounded-lg" data-id="element-33">
              <Clock className="w-4 h-4" data-id="element-34" />
              <span className="font-mono text-lg" data-id="element-35">{timeString}</span>
            </div>
          </div>

          <div className="p-6 md:p-10" data-id="element-36">
            <h2 className="text-3xl md:text-4xl font-black text-center mb-8" data-id="element-37">
              Accede hoy al sistema completo
            </h2>

            <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-38">
              {/* Left: What they get */}
              <div data-id="element-39">
                <ul className="space-y-4" data-id="element-40">
                  {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-41">
                      <div className="bg-brand-green/20 p-1 rounded-full flex-shrink-0 mt-0.5" data-id="element-42">
                        <Check className="w-4 h-4 text-brand-green" data-id="element-43" />
                      </div>
                      <span className="text-gray-200 font-medium" data-id="element-44">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* Right: Price & CTA */}
              <div className="bg-navy-900 p-6 md:p-8 rounded-2xl border border-navy-700 text-center flex flex-col h-full justify-center" data-id="element-45">
                <div className="mb-2" data-id="element-46">
                  <span className="text-gray-500 line-through text-xl font-medium" data-id="element-47">
                    {formattedOldPrice}
                  </span>
                </div>
                <div className="mb-2" data-id="element-48">
                  <span className="text-5xl md:text-6xl font-black text-brand-green" data-id="element-49">
                    {formattedPrice}
                  </span>
                </div>
                <div className="inline-block bg-navy-800 text-gray-300 text-sm px-4 py-1.5 rounded-full mb-8 font-medium border border-navy-700" data-id="element-50">
                  Precio especial · Pago único · Tuyo para siempre
                </div>

                <Button href="https://pay.hotmart.com/V105318931X?checkoutMode=10" className="mb-4 shadow-brand-green/30" data-id="element-51">
                  🔥 Quiero el Megapack ahora
                </Button>

                
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-navy-700" data-id="element-52">
              <TrustBadges data-id="element-53" />
              <div className="flex justify-center gap-4 mt-6 opacity-50 grayscale" data-id="element-54">
                {/* Simulated payment icons */}
                <div className="h-8 w-12 bg-white rounded flex items-center justify-center text-[10px] font-bold text-black" data-id="element-55">
                  VISA
                </div>
                <div className="h-8 w-12 bg-white rounded flex items-center justify-center text-[10px] font-bold text-black" data-id="element-56">
                  MC
                </div>
                <div className="h-8 w-12 bg-white rounded flex items-center justify-center text-[10px] font-bold text-black" data-id="element-57">
                  AMEX
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}